import React, { useEffect, useState } from "react";

import styles from "./Password.module.css";

import eyeIcon from "../../icons/eye.svg";
import crossedEyeIcon from "../../icons/eye-crossed.svg";

const Password = ({ inputClassName,width,height,onShowChange, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (onShowChange) onShowChange(showPassword);
  }, [showPassword, onShowChange]);

  const handleTogglingShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div
    style={{
      width,
    }}
     className={styles.passwordContainer}>
      <input
      style={{
        height
      }}
        type={showPassword ? "text" : "password"}
        {...rest}
            className={`${styles.passwordInput} ${inputClassName || ""}`}

      />
      <img
        src={showPassword ? eyeIcon : crossedEyeIcon}
        alt="eye"
        onClick={handleTogglingShowPassword}
        className={styles.eyeIcon}
      />
    </div>
  );
};

export default Password;
